import { jsx as _jsx } from "react/jsx-runtime";
import { TextAlpha } from '@yonderland/andes-react';
import { useAvailabilityDescription } from '../../../hooks/useAvailabilityDescription';
export const AvailabilityDescriptionAlpha = ({ unavailableProduct }) => {
    const { getKeyForText } = useAvailabilityDescription(unavailableProduct);
    if (!getKeyForText()) {
        return null;
    }
    return (_jsx(TextAlpha, { testId: "availability_description", variant: "subheadingM", as: "h3", children: getKeyForText() }));
};
